export interface DashboardSummaryInfo {
  impres: number;
  clicks: number;
  ctr: string;
  campaignCount: number;
}

export type CampaignDashboardRecord = {
  campaignName: string;
  campaignId: number;
  adType: string;
  agencyId: number;
  vendorNumber: string;
  agencyName: string;
  startDate: string;
  endDate: string;
  budget: number;
  spent: number;
  dailyTargetBudget: number;
  olapExpectedSpent: number;
  olapActualSpent: number;
  bidPrice: number;
  optimize: string;
  orderId: number;
  orderNumber: string;
  orderName: string;
  currency: string;
  currencyRate: number;
  l1ObjectId: number;
  tags: CampaignDashboardFilterTag[];
};

export enum CampaignDashboardFilterTag {
  ALL = 'ALL',
  NEED_INCREASE_CPC_BID = 'NEED_INCREASE_CPC_BID',
  NEED_INCREASE_CPM_BID = 'NEED_INCREASE_CPM_BID',
  NEED_CHANGE_TO_ACCELERATED_DELIVERY = 'NEED_CHANGE_TO_ACCELERATED_DELIVERY',
  NEED_ADD_KEYWORDS = 'NEED_ADD_KEYWORDS',
  NEED_INCREASE_BUDGET_TO_MAINTAIN_PERFORMANCE = 'NEED_INCREASE_BUDGET_TO_MAINTAIN_PERFORMANCE',
  DAILY_BUDGET_REACHED = 'DAILY_BUDGET_REACHED',
  STOP_OUT_OF_STOCK_PRODUCTS = 'STOP_OUT_OF_STOCK_PRODUCTS'
}
